import script from "./esInputCheckbox.vue?vue&type=script&setup=true&lang=ts"
export * from "./esInputCheckbox.vue?vue&type=script&setup=true&lang=ts"

import "./esInputCheckbox.vue?vue&type=style&index=0&id=6effec32&scoped=true&lang=css"

import exportComponent from "/home/aschmuck/wk/eSklepios/medsw/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-6effec32"]])

export default __exports__